import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { useCustomPageTitle } from '../hooks/usePageTitle';

const Contact = () => {
  useCustomPageTitle('Contact');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Construire le lien mailto avec les données du formulaire
    const mailtoLink = `mailto:support@simulreno.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `De: ${formData.fullName}\nEmail: ${formData.email}\n\n${formData.message}`
    )}`;
    
    // Ouvrir le client email
    window.location.href = mailtoLink;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-primary mb-8">Contactez-nous</h1>

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-6 space-y-6">
        <div>
          <label htmlFor="fullName" className="block text-sm font-medium text-neutral-700 mb-1">
            Nom complet
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
            className="input w-full"
            placeholder="Votre nom"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="input w-full"
            placeholder="votre@email.com"
          />
        </div>

        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-neutral-700 mb-1">
            Sujet
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            className="input w-full"
            placeholder="Sujet de votre message"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-neutral-700 mb-1">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows={5}
            className="input w-full"
            placeholder="Votre message..."
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary w-full flex items-center justify-center"
        >
          <Send className="h-4 w-4 mr-2" />
          Envoyer le message
        </button>
      </form>
    </div>
  );
};

export default Contact;